<template>
	<ul class="mainmenu">
		<li>
			<router-link to="/">首页</router-link>
		</li>
		<li class="has-droupdown has-menu-child-item">
			<a href="#">
				产品中心
				<Icon name="plus" class="collapse-icon plus" />
				<Icon name="minus" class="collapse-icon minus" />
			</a>
			<ul class="submenu">
				<li><router-link to="/products/1">边缘控制器</router-link></li>
				<li><router-link to="/products/2">MAC系列控制器</router-link></li>
				<li><router-link to="/products/4">分布控制器</router-link></li>
				<li><router-link to="/products/6">EDC系列可编程控制平台</router-link></li>
				<li><router-link to="/products/6">CIO系列小型控制器</router-link></li>
				<li><router-link to="/products/8">扩展IO模块</router-link></li>
				<li><router-link to="/products/13">电源模块</router-link></li>
				<li><router-link to="/products/14">专用产品</router-link></li>
				<li><router-link to="/products/16">环网伺服&伺服电机</router-link></li>
				<li><router-link to="/products/17">软件产品</router-link></li>
			</ul>
		</li>
		
		<li class="has-droupdown has-menu-child-item">
			<a href="#">
				技术支持
				<Icon name="plus" class="collapse-icon plus" />
				<Icon name="minus" class="collapse-icon minus" />
			</a>			
		</li>

		<li class="with-megamenu has-menu-child-item">
			<a href="#">
				实施案例
				<Icon name="plus" class="collapse-icon plus" />
				<Icon name="minus" class="collapse-icon minus" />
			</a>
			<div class="rn-megamenu">
				<div class="wrapper">
					<div class="row row--100">
						<div class="col-lg-4 single-mega-item">
							<ul class="mega-menu-item">
								<li><router-link to="/project-show/1">协同自动化系统</router-link></li>
								<li><router-link to="/project-show/2">网络化可编程控制系统</router-link></li>
								<li><router-link to="/project-show/3">数控和机器人控制系统</router-link></li>
								<li><router-link to="/project-show/4">软仪表控制系统</router-link></li>
							</ul>
						</div>
						<div class="col-lg-4 single-mega-item">
							<ul class="mega-menu-item">
								<li><router-link to="/project-show/5">回流焊、波峰焊控制系统</router-link></li>
								<li><router-link to="/project-show/6">螺杆挤出机控制系统</router-link></li>
								<li><router-link to="/project-show/7">九磨头圆钢修磨机控制系统</router-link></li>
								<li><router-link to="/project-show/8">加弹机控制系统</router-link></li>
								<li><router-link to="/project-show/9">空压站控制系统</router-link></li>								
								<li><router-link to="/project-show/10">并联高速拾取机器人</router-link></li>
								<li><router-link to="/project-show/11">码垛机器人控制系统</router-link></li>
							</ul>
						</div>
						<div class="col-lg-4 single-mega-item">
							<ul class="mega-menu-item">
								<li><router-link to="/project-show/12">智能楼宇监控系统</router-link></li>
								<li><router-link to="/project-show/13">供热管网监控系统</router-link></li>
								<li><router-link to="/project-show/14">电力数据监控系统</router-link></li>
								<li><router-link to="/project-show/15">企业管理系统</router-link></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</li>
		<li class="has-droupdown has-menu-child-item">
			<a href="/download">
				资料下载
				<Icon name="plus" class="collapse-icon plus" />
				<Icon name="minus" class="collapse-icon minus" />
			</a>
			<ul class="submenu">
				<li>
					<router-link to="/download/software/cfgPr">软件产品</router-link>
				</li>
				<li>
					<router-link to="/download/files/guide">说明文档</router-link>
				</li>
				<li>
					<router-link to="/download/files/driver">示例程序</router-link>
				</li>
			</ul>
		</li>		
		<li>
			<router-link to="/about-us">关于我们</router-link>
		</li>
		<li>
			<router-link to="/contact-us">联系我们</router-link>
		</li>
	</ul>
</template>

<script>
	import Icon from "../../icon/Icon";
	export default {
		name: 'Nav',
		components: {
			Icon
		}
	}
</script>
